import React, { useEffect, useState } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { NotificationBar } from '../components/NotificationBar';
import { HeroSection } from '../components/HeroSection';
import { FearNarrative } from '../components/FearNarrative';
import { SystemSection } from '../components/SystemSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { TrustSection } from '../components/TrustSection';
import { PolicyModal } from '../components/PolicyModal';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  const [modalState, setModalState] = useState<{
    open: boolean;
    tab: 'privacy' | 'terms';
  }>({
    open: false,
    tab: 'privacy'
  });
  return <div className="min-h-screen bg-white font-opensans selection:bg-brand-orange selection:text-white relative" data-id="element-202">
      <NotificationBar data-id="element-203" />
      <main data-id="element-204">
        <HeroSection data-id="element-205" />
        <FearNarrative data-id="element-206" />
        <SystemSection data-id="element-207" />
        <BonusSection data-id="element-208" />
        <ValueStack data-id="element-209" />
        <TrustSection onOpenPrivacy={() => setModalState({
        open: true,
        tab: 'privacy'
      })} onOpenTerms={() => setModalState({
        open: true,
        tab: 'terms'
      })} data-id="element-210" />
      </main>

      <PolicyModal isOpen={modalState.open} activeTab={modalState.tab} onClose={() => setModalState(prev => ({
      ...prev,
      open: false
    }))} onTabChange={tab => setModalState(prev => ({
      ...prev,
      tab
    }))} data-id="element-211" />
    </div>;
}